import { vslApi } from '@/api';

export default {
  fetchVesselList() {
    return vslApi.get('/v1/vessels');
  },
};
